"use client";

import { useEffect } from "react";

export function ExternalFeaturePolyfill() {
  useEffect(() => {
    const ensure = () => {
      try {
        const w: any = window as any;
        if (!w.args || typeof w.args !== "object") {
          w.args = {};
        }
        if (!w.args.site || typeof w.args.site !== "object") {
          w.args.site = {};
        }
        const site = w.args.site;
        if (!Array.isArray(site.enabledFeatures)) {
          // Coerce to an array to guarantee .includes exists
          site.enabledFeatures = Array.isArray(site.enabledFeatures)
            ? site.enabledFeatures
            : [];
        }
      } catch {
        // no-op
      }
    };

    // Ensure immediately and for a short period while external scripts initialize
    ensure();
    const intervalId = window.setInterval(ensure, 500);
    const timeoutId = window.setTimeout(() => {
      window.clearInterval(intervalId);
    }, 10000); // stop after 10s

    return () => {
      window.clearInterval(intervalId);
      window.clearTimeout(timeoutId);
    };
  }, []);

  return null;
}
